<template>
  <section class="address-list">
    <IntercomDeleteConfirm
      v-if="this.intercomDeleteConfirm.active"
      :selected-count="rowsSelected.length"
      :loading="intercomDeleteLoading"
      @approve="
        () => {
          this.removeIntercoms()
        }
      "
      @close="
        () => {
          this.intercomDeleteConfirm.active = false
        }
      "
    />
    <div class="address-list__filters">
      <Filters v-model="filtersActive" :filters="filters" />
    </div>
    <div class="address-list__list">
      <Table
        v-model="rowsSelected"
        :columns="tableColumns"
        :rows="tableRows"
        @rowClick="onRowClick"
      />
      <Pagination
        v-model="intercomsMeta.current_page"
        v-bind="{
          totalItems: intercomsMeta.total,
          itemsByPage: intercomsMeta.per_page,
        }"
        @switchPage="onSwitchPage"
      />
    </div>
    <div class="address-list__actions">
      <Actions
        :actions="rowsSelected.length ? actions.selected : actions.default"
      />
    </div>
  </section>
</template>

<script>
import Filters from '../../components/Filters.vue'
import Table from '../../components/Table.vue'
import Actions from '../../components/Actions.vue'
import MockIntercomAddressList from '../../mixins/Mock/MockIntercomAddressList.js'
import Pagination from '../../components/Pagination.vue'
import IntercomDeleteConfirm from '../Popup/IntercomDeleteConfirm.vue'

export default {
  name: 'AddressList',
  mixins: [MockIntercomAddressList],
  components: { Filters, Table, Actions, Pagination, IntercomDeleteConfirm },
  data() {
    return {
      filtersActive: {},
      rowsSelected: [],
    }
  },
  watch: {
    filtersActive: {
      handler(value) {
        this.filterIntercom(value)
      },
      deep: true,
    },
  },
  computed: {
    intercomsMeta() {
      return this.$store.getters.intercomsMeta
    },
  },
}
</script>

<style lang="scss" scoped>
.address-list {
  &__filters {
    margin: 0px $space-md $space-lg;
  }

  &__list {
    margin: 0px $space-md $space-lg;
  }
}
</style>
